import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import '../assets/css/DesignFitOut.css';
import heroImage from '../assets/images/banner/design-fitout.png';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import ContactForm from '../components/ContactForm';  
import HomeCaseStudy from '../components/HomeCaseStudy';
import ClientSlider from '../components/ClientSlider';
import { FaBuilding, FaChartLine, FaPencilRuler, FaLayerGroup, FaTools, FaUsers, FaDesktop, FaIndustry, FaTools as FaInstall, FaHandshake, FaRegObjectUngroup, FaRegBuilding, FaCube } from 'react-icons/fa';
import { API_BASE_URL } from '../config';

import axios from 'axios';
import product1 from '../assets/images/fit-out/1.png';
import product2 from '../assets/images/fit-out/2.png';
import product3 from '../assets/images/fit-out/3.png';
import product4 from '../assets/images/fit-out/4.png';
import product5 from '../assets/images/fit-out/1.png';

const DesignFitOut = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: '', message: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handlePhoneChange = (value) => {
    setFormData(prevState => ({
      ...prevState,
      phone: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: '', message: '' });

    const formDataToSend = new FormData();
    Object.keys(formData).forEach(key => {
      formDataToSend.append(key, formData[key]);
    });

    try {
      const response = await axios({
        method: 'post',
        url: `${API_BASE_URL}submit-contact.php`,
        data: formDataToSend,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
      if (response.data.success) {
        setStatus({
          type: 'success',
          message: 'Thank you for your message. We will get back to you soon!'
        });
        setFormData({
          fullName: '',
          email: '',
          phone: '',
          subject: '',
          message: ''
        });
      } else {
        throw new Error(response.data.message || 'Something went wrong');
      }
    } catch (error) {
      console.error('Submission error:', error);
      setStatus({
        type: 'error',
        message: error.response?.data?.message || error.message || 'Failed to submit form. Please try again later.'
      });
    } finally {
      setLoading(false);
    }
  };

  const breadcrumbLinks = [
    { text: 'Home', url: '/' },
    { text: 'DesignFitOut', url: '/design-fitout' }
  ];

  const fitoutProjects = [
    {
      id: 1,
      title: "OFFICE SPACE PLANNING",
      description: "Office space planning is essential in arranging a workspace to maximize efficiency, productivity, and functionality. It involves carefully considering factors such as the available space, the needs of the employees, workflow patterns, and ergonomic principles.",
      icon: <FaBuilding />
    },
    {
      id: 2,
      title: "OFFICE FIT-OUT WORKS",
      description: "Transforming your office space into a functional, aesthetically pleasing, and productive environment tailored to your needs.",
      icon: <FaTools />
    },
    {
      id: 3,
      title: "OFFICE INTERIOR DESIGN",
      description: "From concept development to final implementation, we manage every aspect of the design process, ensuring seamless execution and stunning results.",
      icon: <FaPencilRuler />
    }
  ];

  const services = [
    {
      id: 1,
      title: "Office Interior Design",
      description: "Custom space planning and layout optimization for open offices, private cabins, meeting rooms, and collaborative zones.",
      image: product1
    },
    {
      id: 2,
      title: "Office Fit-Out & Renovation",
      description: "End-to-end office fit-out including partitioning, false ceilings, flooring, and lighting installation.",
      image: product2
    },
    {
      id: 3,
      title: "Joinery & Materials",
      description: "Expert custom joinery work including reception desks, cabinetry, wall paneling, and built-in storage.",
      image: product3
    },
    {
      id: 4,
      title: "Furniture Supply & Installation",
      description: "Custom-made and modular office furniture solutions designed for durability and aesthetics.",
      image: product4
    }
  ];

  return (
    <div className="design-fitout-page">
      <Helmet>
        <title>Office Fit-Out & Interior Design - Design Craft | Complete Workspace Solutions Dubai UAE</title>
        <meta 
          name="description" 
          content="Transform your office with Design Craft's complete fit-out and interior design services in Dubai. We provide office space planning, custom joinery, furniture installation, and refurbishment solutions across UAE. Get expert consultation for your workspace transformation." 
        />
        <meta 
          name="keywords" 
          content="office fit-out Dubai, office interior design UAE, office refurbishment Dubai, workspace design, office space planning, custom joinery Dubai, office renovation, commercial interior design, office furniture installation, fitout contractor UAE, office design consultation" 
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Design Craft" />
        
        {/* Open Graph Tags */}
        <meta property="og:title" content="Office Fit-Out & Interior Design - Design Craft Dubai UAE" />
        <meta 
          property="og:description" 
          content="Complete office fit-out and interior design solutions in Dubai. From space planning to furniture installation, we transform workspaces across UAE with expert consultation and custom solutions." 
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Design Craft" />
     
        
        {/* Additional SEO Tags */}
        <meta name="geo.region" content="AE" />
        <meta name="geo.placename" content="Dubai, UAE" />
        <meta name="business.contact_data.locality" content="Dubai" />
        <meta name="business.contact_data.region" content="UAE" />
        
        {/* Service-specific tags */}
        <meta name="service" content="Office Fit-Out" />
        <meta name="service" content="Interior Design" />
        <meta name="service" content="Office Refurbishment" />
        <meta name="service" content="Space Planning" />
        
      </Helmet>
      {/* Hero Section */}
      <div className="hero-section1">
        <div className="hero-image">
          <img src={heroImage} alt="Design Fitout" />
          <div className="hero-overlay"></div>
        </div>
        <div className="hero-content">
          <h1>OFFICE FIT-OUT, DESIGN & REFURBISHMENT</h1>
          <p>Browse. Pick. Procure.</p>
        </div>
      </div>

      {/* Workspace Transformation Section */}
      <div className="workspace-transform-section">
        <div className="transform-content">
          <div className="transform-left">
            <img src={heroImage} alt="Workspace Design" className="transform-image" />
          </div>
          <div className="transform-right">
            <h2>Transforming Your Workspace in Dubai</h2>
            <p>Design Craft is one of the most trusted companies in Dubai for office interiors and furniture. We offer office space planning, office interior design, and office refurbishment services.</p>
            
            <div className="services-list">
              <div className="service-item">
                <FaLayerGroup className="service-icon" />
                <span>Office Space Planning</span>
              </div>
              <div className="service-item">
                <FaTools className="service-icon" />
                <span>Office Fit-Out Works</span>
              </div>
              <div className="service-item">
                <FaPencilRuler className="service-icon" />
                <span>Office Interior Design</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="design-fitout-container">
        <h1 className="main-title">Transforming Your Workspace in Dubai</h1>

        <div className="design-fitout-grid">
          {fitoutProjects.map((fitout) => (
            <div key={fitout.id} className="fitout-card">
              <div className="icon-container">
                {fitout.icon}
              </div>
              <h3>{fitout.title}</h3>
              <p>{fitout.description}</p>
            </div>
          ))}
        </div>
      </div>

      <HomeCaseStudy />
      

      {/* Workflow Section */}
      <div className="workflow-section">
        <div className="workflow-container">
          <h2 className="workflow-title">Our Process</h2>
          <div className="workflow-ladder">
            <div className="workflow-step">
              <div className="workflow-content left">
                <div className="workflow-icon">
                  <FaUsers className="icon" />
                </div>
                <div className="workflow-text">
                  <h3>Consultation</h3>
                  <p>Understanding your vision and goals to use the complete potential of available space.</p>
                </div>
              </div>
              <div className="workflow-line"></div>
            </div>

            <div className="workflow-step">
              <div className="workflow-content right">
                <div className="workflow-icon">
                  <FaCube className="icon" />
                </div>
                <div className="workflow-text">
                  <h3>Space Planning</h3>
                  <p>We present you with a 3D design to understand how finished project will look.</p>
                </div>
              </div>
              <div className="workflow-line"></div>
            </div>

            <div className="workflow-step">
              <div className="workflow-content left">
                <div className="workflow-icon">
                  <FaIndustry className="icon" />
                </div>
                <div className="workflow-text">
                  <h3>Manufacturing</h3>
                  <p>We will start manufacturing the furniture and fixtures asper the design approved.</p>
                </div>
              </div>
              <div className="workflow-line"></div>
            </div>

            <div className="workflow-step">
              <div className="workflow-content right">
                <div className="workflow-icon">
                  <FaTools className="icon" />
                </div>
                <div className="workflow-text">
                  <h3>Installation</h3>
                  <p>With our inhouse expertise, you can trust us with the delivery & installation to be very quick.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Services Section */}
      <div className="services-section">
        <h2 className="services-title">Services</h2>
        <div className="services-container">
          <div className="services-grid">
            {services.map((service) => (
              <div key={service.id} className="service-card">
                <div className="service-image">
                  <img src={service.image} alt={service.title} />
                </div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <ClientSlider />
      <ContactForm />
    </div>
  );
};

export default DesignFitOut; 